import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ContactHeroProps {
  className?: string;
}

const ContactHero = ({ className = '' }: ContactHeroProps) => {
  return (
    <section className={`relative bg-gradient-to-br from-primary via-gray-800 to-gray-900 text-primary-foreground py-16 lg:py-24 ${className}`}>
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center w-16 h-16 lg:w-20 lg:h-20 bg-accent rounded-full mb-6">
            <Icon name="ChatBubbleLeftRightIcon" size={32} variant="solid" className="text-accent-foreground" />
          </div>
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-heading font-bold mb-6">
            Get in Touch
          </h1>
          <p className="text-lg lg:text-xl text-primary-foreground/90 leading-relaxed">
            Ready to start your fitness journey? We're here to answer your questions and help you find the perfect program. Reach out through your preferred channel.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;